<template>
  <ModalCardDefault :title="'Desconto'" :displayNoButton="false">
    <TextFieldMoney
      v-model="discount"
      ref="refDiscount"
      placeholder="Valor"
      label="Valor"
      @change="confirm"
    />

    <template v-slot:actions>
      <Button color="secondary" rounded @click="confirm" class="mr-3">
        <span class="text-button"
          >Confirmar
          <span class="text-button font-weight-black yellow--text"
            >(Enter)</span
          >
        </span>
      </Button>
      <Button
        color="primary"
        rounded
        @click="$emit('update:dialogModal', false)"
      >
        <span class="text-button"
          >Fechar
          <span class="text-button font-weight-black yellow--text">(Esc)</span>
        </span>
      </Button>
    </template>
  </ModalCardDefault>
</template>

<script>
import { TextFieldMoney, Button } from '@/components/vuetify';
import ModalCardDefault from '@/components/ModalCardDefault';
import InputFocusMixin from '@/mixins/InputFocusMixin';

export default {
  name: 'PdvDiscount',
  components: { ModalCardDefault, TextFieldMoney, Button },
  data() {
    return {
      discount: 0,
    };
  },
  created() {
    window.addEventListener('keydown', this.actionListener);
  },
  destroyed() {
    window.removeEventListener('keydown', this.actionListener);
  },
  mixins: [InputFocusMixin],
  methods: {
    confirm() {
      if (!this.discount || this.discount == 0) {
        this.$noty.error('Digite o valor do Desconto');

        return false;
      }
      this.$emit('confirmDialog', {
        action: 'addDiscount',
        data: parseFloat(this.discount),
      });
    },
    actionListener(event) {
      if (event.key === 'Enter') {
        this.confirm();
      }
    },
  },
  mounted() {
    this.focusInputs(this.$refs.refDiscount.$children[0].$children[0]);
  },
};
</script>
